export default __webpack_public_path__ + "static/media/about-hero-mobile.feb1435e.svg";